import React from 'react';

import useTranslation from '@hooks/useTranslation';

import { IMAGE_TYPES } from '../../constants/imageTypes';
import type { IGalleryPhoto } from '../../constants/sensorGalleryType';
import style from './style.module.scss';

interface IProps {
  currentImage: IGalleryPhoto;
  isAllChecked: boolean;
  equipmentName: string;
}

const CurrentImage = ({ currentImage, isAllChecked, equipmentName }: IProps) => {
  const { t } = useTranslation();
  const { imageType, installationPoint, url } = currentImage;

  const installationPointImageName =
    installationPoint?.length === 1
      ? installationPoint[0].name
      : t(`Installation Point ({count})`, { count: installationPoint?.length });
      
  const installationPointImageLabel = isAllChecked ? equipmentName : installationPointImageName;

  return (
    <div className={style.currentPhoto}>
      <img src={url} alt={t('photo')} />
      {!!imageType && <label className={style.labelImageType}>{t(IMAGE_TYPES[imageType])}</label>}
      {!!installationPoint?.length && (
        <label
          className={style.labelInstapoints}
          dangerouslySetInnerHTML={{
            __html: installationPointImageLabel,
          }}
        />
      )}
    </div>
  );
};

export default CurrentImage;
